/* Clarity: explicit Shopify analytics consent, strict masking configured in project. */
(function () {
  'use strict';
  if (window.__plClarityV1) return;
  window.__plClarityV1 = true;
  var query = new URLSearchParams(window.location.search), loaded = false, stopped = false;
  var deniedByEvent = false, lastAd = null;
  try {
    if (query.get('pl_clarity') === 'off') window.localStorage.setItem('pl_clarity_optout', '1');
    if (query.get('pl_clarity') === 'on') window.localStorage.removeItem('pl_clarity_optout');
  } catch (_) { /* Storage may be unavailable; URL opt-out still applies. */ }
  function excluded() {
    if (window.location.hostname !== 'pixellifestyle.com' && window.location.hostname !== 'www.pixellifestyle.com') return true;
    if (query.get('pl_clarity') === 'off' || (window.Shopify && window.Shopify.designMode) || document.querySelector('#PBarNextFrame')) return true;
    try { if (window.localStorage.getItem('pl_clarity_optout') === '1') return true; } catch (_) {}
    var path = window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '');
    if (!/^(?:\/?$|\/products\/[^/]+\/?$|\/collections(?:\/[^/]+)?\/?$|\/collections\/[^/]+\/products\/[^/]+\/?$)/.test(path)) return true;
    var unsafe = false;
    query.forEach(function (value, key) {
      // Ads append these to catalog links. Keep unknown/sensitive query keys blocked.
      // Validate new values as well as names; do not widen consent or page access.
      if (/^(gad_source|gad_campaignid|rdt_cid|adset_id)$/.test(key)) {
        if (!/^[0-9]{1,32}$/.test(value) || /\s/.test(value)) unsafe = true;
      } else if (/^(gbraid|wbraid)$/.test(key)) {
        if (!/^[A-Za-z0-9_-]{1,512}$/.test(value) || /\s/.test(value)) unsafe = true;
      } else if (key === 'country') {
        if (!/^[A-Z]{2}$/.test(value) || /\s/.test(value)) unsafe = true;
      } else if (key === 'currency') {
        if (!/^[A-Z]{3}$/.test(value) || /\s/.test(value)) unsafe = true;
      } else if (!/^(variant|page|sort_by|utm_source|utm_medium|utm_campaign|utm_content|utm_term|utm_id|campaign_id|ad_id|fbclid|gclid|_gl|pl_clarity)$/.test(key)) unsafe = true;
    });
    return unsafe;
  }
  function allowed() {
    try {
      var cp = window.Shopify.customerPrivacy;
      return !deniedByEvent && cp.analyticsProcessingAllowed() === true && cp.currentVisitorConsent().analytics === 'yes';
    }
    catch (_) { return false; }
  }
  function stop() {
    if (!loaded || stopped) return;
    window.clarity('consentv2', {analytics_Storage:'denied', ad_Storage:'denied'});
    window.clarity('stop');
    stopped = true;
  }
  function advertising() {
    try {
      var cp = window.Shopify.customerPrivacy;
      return cp.marketingAllowed() === true && cp.currentVisitorConsent().marketing === 'yes' ? 'granted' : 'denied';
    } catch (_) { return 'denied'; }
  }
  function sync() {
    if (excluded() || !allowed()) { stop(); return; }
    if (stopped) return;
    var ad = advertising();
    if (loaded) {
      if (ad !== lastAd) window.clarity('consentv2', {analytics_Storage:'granted', ad_Storage:ad});
      lastAd = ad;
      return;
    }
    loaded = true;
    window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    lastAd = ad;
    window.clarity('consentv2', {analytics_Storage:'granted', ad_Storage:ad});
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/yq40i899f6';
    document.head.appendChild(script);
  }
  document.addEventListener('visitorConsentCollected', function (event) {
    deniedByEvent = !event.detail || event.detail.analyticsAllowed !== true;
    sync();
  });
  sync();
  // Also catches delayed Shopify API availability and permission changes without an event.
  setInterval(sync, 1000);
}());
